import React, { ReactNode } from 'react';
import { Card } from '../../components/ui/card';
import { ArrowDown, ArrowUp, Minus } from 'lucide-react';

interface StatCardProps {
  title: string;
  value: string | number;
  icon?: ReactNode;
  color?: string;
  trend?: 'up' | 'down' | 'neutral';
  trendValue?: string | number;
}

const StatCard: React.FC<StatCardProps> = ({ 
  title, 
  value, 
  icon, 
  color = 'bg-blue-500', 
  trend,
  trendValue
}) => {
  return (
    <Card className="p-4">
      <div className="flex justify-between items-start">
        <div>
          <p className="text-sm text-muted-foreground mb-1">{title}</p>
          <p className="text-2xl font-bold">{value}</p>
          
          {trend && (
            <div className="flex items-center mt-2 text-xs">
              {trend === 'up' ? (
                <div className="flex items-center text-green-500">
                  <ArrowUp className="h-3 w-3 mr-1" />
                  <span>{trendValue || '↑'}</span>
                </div>
              ) : trend === 'down' ? (
                <div className="flex items-center text-red-500">
                  <ArrowDown className="h-3 w-3 mr-1" />
                  <span>{trendValue || '↓'}</span>
                </div>
              ) : (
                <div className="flex items-center text-gray-500">
                  <Minus className="h-3 w-3 mr-1" />
                  <span>No change</span>
                </div>
              )}
            </div>
          )}
        </div>
        
        {icon && (
          <div className={`p-2.5 rounded-full ${color} bg-opacity-20`}>
            {icon}
          </div>
        )}
      </div>
    </Card>
  );
};

export default StatCard;